export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20496)">
                <path
                    d="M26 13.5H27.5C28.3284 13.5 29 14.1716 29 15V23C29 23.8284 28.3284 24.5 27.5 24.5H4.5C3.67157 24.5 3 23.8284 3 23V15C3 14.1716 3.67157 13.5 4.5 13.5H16"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 24.5H6V26.5H10V24.5Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M26 24.5H22V26.5H26V24.5Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M21 19.5C23.7615 19.5 26 17.2615 26 14.5C26 11.7385 23.7615 9.5 21 9.5C18.2385 9.5 16 11.7385 16 14.5C16 17.2615 18.2385 19.5 21 19.5Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path d="M14 8.5L15.0495 9.54954" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17 6.5L17.6256 7.84673" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 5.5V6.98519" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.0499 8.5L27 9.54954" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M24.6256 6.5L24 7.84673" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1975_20496">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
